import { UserService } from '../services/UserService'

export function useUserService(): UserService {
  return new UserService(useApiClient(), useUserStore())
}